import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import MostWinsWrestlerMobile from '../../../pages/Mobile/Stats/MostWinsWrestlerMobile';
import MostWinsStats from '../../../pages/MostWinsStats';
import MostWinsWrestlerFemaleMobile from '../../../pages/Mobile/Stats/MostWinsFemaleMobile';

const MostWinsWrestlerFemaleResponsive = () => {
    const { isMobile } = useResponsiveRedux(); 
    return isMobile ? <MostWinsWrestlerFemaleMobile /> : <MostWinsStats isWoman={true} />;
}; 

export default MostWinsWrestlerFemaleResponsive;